/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventStatusEnum } from './EventStatusEnum';
import {
    EventStatusEnumFromJSON,
    EventStatusEnumFromJSONTyped,
    EventStatusEnumToJSON,
    EventStatusEnumToJSONTyped,
} from './EventStatusEnum';

/**
 * Emission Event serializer used for update operations.
 * @export
 * @interface EmissionEventUpdate
 */
export interface EmissionEventUpdate {
    /**
     * 
     * @type {string}
     * @memberof EmissionEventUpdate
     */
    mainEvent?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EmissionEventUpdate
     */
    responsible?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EmissionEventUpdate
     */
    reviewer?: number | null;
    /**
     * 
     * @type {EventStatusEnum}
     * @memberof EmissionEventUpdate
     */
    eventStatus: EventStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof EmissionEventUpdate
     */
    extraNotes?: string;
    /**
     * 
     * @type {any}
     * @memberof EmissionEventUpdate
     */
    formData?: any | null;
}



/**
 * Check if a given object implements the EmissionEventUpdate interface.
 */
export function instanceOfEmissionEventUpdate(value: object): value is EmissionEventUpdate {
    if ((!('eventStatus' in (value as Record<string, any>)) && !('event_status' in (value as Record<string, any>))) || ((value as Record<string, any>)['eventStatus'] === undefined && (value as Record<string, any>)['event_status'] === undefined)) return false;
    return true;
}

export function EmissionEventUpdateFromJSON(json: any): EmissionEventUpdate {
    return EmissionEventUpdateFromJSONTyped(json, false);
}

export function EmissionEventUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmissionEventUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'mainEvent': json['main_event'] === undefined ? undefined : json['main_event'] === null ? null : json['main_event'],
        'responsible': json['responsible'] === undefined ? undefined : json['responsible'] === null ? null : json['responsible'],
        'reviewer': json['reviewer'] === undefined ? undefined : json['reviewer'] === null ? null : json['reviewer'],
        'eventStatus': EventStatusEnumFromJSON(json['event_status']),
        'extraNotes': json['extra_notes'] == null ? undefined : json['extra_notes'],
        'formData': json['form_data'] === undefined ? undefined : json['form_data'] === null ? null : json['form_data'],
    };
}

export function EmissionEventUpdateToJSON(json: any): EmissionEventUpdate {
    return EmissionEventUpdateToJSONTyped(json, false);
}

export function EmissionEventUpdateToJSONTyped(value?: EmissionEventUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'main_event': value['mainEvent'],
        'responsible': value['responsible'],
        'reviewer': value['reviewer'],
        'event_status': EventStatusEnumToJSON(value['eventStatus']),
        'extra_notes': value['extraNotes'],
        'form_data': value['formData'],
    };
}

